import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    constructor(private http: HttpClient) {}

    login(email, password) {
        const url = '/api/login';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
            }),
        };
        const body = `userName=${encodeURIComponent(
            email,
        )}&password=${encodeURIComponent(password)}&grant_type=password`;
        return this.http.post(url, body, httpOptions);
    }
}
